import { render, staticRenderFns } from "./EditarSeccion.vue?vue&type=template&id=0cfe8d5d&"
import script from "./EditarSeccion.vue?vue&type=script&lang=js&"
export * from "./EditarSeccion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports